/**
 * @spec docs/specs/features/staking-position-ui.md#wallet-integration
 * Wallet context definition and types
 */
import { createContext } from 'react';
import type { ConnectedWallet } from '@privy-io/react-auth';

export interface WalletContextValue {
  /** The currently selected wallet address (checksummed) */
  selectedAddress: string | null;
  /** Set the selected wallet by address */
  setSelectedAddress: (address: string) => void;
  /** All connected wallets from Privy */
  wallets: ConnectedWallet[];
  /** The currently selected wallet object */
  selectedWallet: ConnectedWallet | null;
  /** Whether Privy has finished initializing */
  isReady: boolean;
}

export const WalletContext = createContext<WalletContextValue | null>(null);
